import { isLocalStorageAvailable } from "@/utils/utils";

export interface StorageService {
  get(key: string): any | null;
  set(key: string, value: any): void;
  remove(key: string): void;
  clear(): void;
}

export class LocalStorageService implements StorageService {
  private available: boolean;

  constructor() {
    this.available = isLocalStorageAvailable();
  }

  public get(key: string): any | null {
    if (!this.available) return null;

    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.warn(`Error getting item ${key} from localStorage:`, error);
      return null;
    }
  }

  public set(key: string, value: any): void {
    if (!this.available) return;

    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn(`Error setting item ${key} in localStorage:`, error);
    }
  }

  public remove(key: string): void {
    if (!this.available) return;

    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`Error removing item ${key} from localStorage:`, error);
    }
  }

  public clear(): void {
    if (!this.available) return;

    try {
      localStorage.clear();
    } catch (error) {
      console.warn('Error clearing localStorage:', error);
    }
  }
}

